export default "__VITE_ASSET__f7e6e20e__"